export const clientToken = assertValue(
  process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
  'Missing environment variable: NEXT_PUBLIC_DATADOG_CLIENT_TOKEN'
);

export const applicationId = assertValue(
  process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
  'Missing environment variable: NEXT_PUBLIC_DATADOG_APPLICATION_ID'
);

export const site = assertValue(
  process.env.NEXT_PUBLIC_DATADOG_SITE,
  'Missing environment variable: NEXT_PUBLIC_DATADOG_SITE'
);

const ENV_MAPPING = {
  production: 'prod',
  preview: 'preview',
  development: 'dev',
} as const;

export const env =
  ENV_MAPPING[
    (process.env.NEXT_PUBLIC_VERCEL_ENV ||
      'development') as keyof typeof ENV_MAPPING
  ] || 'dev';

export const version = '1';

export const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';

function assertValue<T>(v: T | undefined, errorMessage: string): T {
  if (v === undefined) {
    throw new Error(errorMessage);
  }

  return v;
}
